import PropTypes from 'prop-types';

export const dataNotificationsModel = PropTypes.arrayOf(
  PropTypes.shape({
    typeAppNotification: PropTypes.string,
    count: PropTypes.string
  })
);

export const dataErrorNumberModel = PropTypes.shape({
  type: PropTypes.string,
  number: PropTypes.string,
  description: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string
    })
  )
});

export const dataDailyShareModel = PropTypes.shape({
  id: PropTypes.number,
  day: PropTypes.string,
  antena3: PropTypes.number,
  telecinco: PropTypes.number,
  la1: PropTypes.number,
  laSexta: PropTypes.number,
  cuatro: PropTypes.number,
  neox: PropTypes.number,
  nova: PropTypes.number,
  mega: PropTypes.number,
  a3series: PropTypes.number,
  factoriaFiccion: PropTypes.number,
  divinity: PropTypes.number,
  energy: PropTypes.number,
  bemad: PropTypes.number,
  boing: PropTypes.number,
  forta: PropTypes.number,
  la2: PropTypes.number,
  clan: PropTypes.number,
  tdp: PropTypes.number,
  tv24h: PropTypes.number,
  treceTv: PropTypes.number,
  disney: PropTypes.number,
  discovery: PropTypes.number,
  paramount: PropTypes.number,
  ten: PropTypes.number,
  dkiss: PropTypes.number,
  realMadrid: PropTypes.number,
  gol: PropTypes.number,
  tematicas: PropTypes.number,
  pago: PropTypes.number,
  resto: PropTypes.number
});
